import { render, staticRenderFns } from "./SegmentationGroup.vue?vue&type=template&id=7dca0f1a"
import script from "./SegmentationGroup.vue?vue&type=script&lang=js"
export * from "./SegmentationGroup.vue?vue&type=script&lang=js"
import style0 from "./SegmentationGroup.vue?vue&type=style&index=0&id=7dca0f1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports